module.exports = "<div class=\"guide-entry glyphicons file\">\r\n    <i></i>\r\n\r\n    <h4 data-bind=\"title\"></h4>\r\n    <p data-bind=\"description\"></p>\r\n    <p class=\"file-info\">\r\n        <span data-bind=\"file-name\"></span>\r\n        <span data-bind=\"file-size\"></span>\r\n    </p>\r\n    <a class=\"btn btn-primary\" data-bind=\"url\">Download</a>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/guide/entryView.html
 ** module id = 33
 ** module chunks = 0
 **/